import React from 'react';
//UNAUTHENTICATED STACK uses patient styles
// kind of boring given that the styles will stay loaded even if a staff logs in instead
import 'css/index-patient2.scss';
import { NavStack } from '../../../components/Navigation/NavStack';
import { ENVIRONMENT } from '../../../config';
import DebugPage from '../../HomePatient2/DebugPage';
import PatientEntry from '../../HomePatient2/PatientEntry';
import NewLogin from '../../NewLogin';
import ForgotPassword from '../../NewLogin/ForgotPassword';
import ForgotUsername from '../../NewLogin/ForgotUsername';
import PatientRegistration from '../../PatientRegistration';
import { PatientWelcome } from '../../TutorialScreens';
import { Stacks } from '../../../careand-redux/slices/ui/navigation';
import COMMON_ROUTES from './CommonRoutes';

const UnauthenticatedStack = () => {
  return (
    <NavStack
      debugName="UnauthenticatedStack"
      stack={Stacks.Master}
      routes={{
        '/welcome': {
          element: <PatientWelcome />,
          exact: true,
          authenticated: false,
        },
        '/landing': {
          element: <PatientEntry />,
          exact: true,
          authenticated: false,
        },
        '/register/:step?': {
          element: <PatientRegistration />,
          exact: true,
          authenticated: false,
        },
        '/login': {
          element: <NewLogin />,
          exact: true,
          authenticated: false,
        },
        '/login/forgot-username': {
          element: <ForgotUsername />,
          authenticated: false,
        },
        '/login/forgot-password': {
          element: <ForgotPassword />,
          authenticated: false,
        },
        '/debug':
          ENVIRONMENT === 'production'
            ? undefined
            : {
                element: <DebugPage />,
                exact: false,
                authenticated: false,
              },
        ...COMMON_ROUTES,
      }}
    />
  );
};

export default UnauthenticatedStack;
